const originalPrimary = '#01188F';
const comparativePrimary = '#808CC7'; // 50% mix of originalPrimary and white
const originalSecondary = '#B40091';
const comparativeSecondary = '#D980C8'; // 50% mix of originalSecondary and white
const originalTertiary = '#006D21';
const comparativeTertiary = '#80B690'; // 50% mix of originalTertiary and white
const originalQuaternary = '#0078D7';
const comparativeQuaternary = '#8CC2ED'; // 50% mix of originalQuaternary and white

export const colors = [
  {
    original: originalPrimary,
    comparative: comparativePrimary,
  },
  {
    original: originalSecondary,
    comparative: comparativeSecondary,
  },
  {
    original: originalTertiary,
    comparative: comparativeTertiary,
  },
  {
    original: originalQuaternary,
    comparative: comparativeQuaternary,
  },
];

export const primary = colors[0];

export const secondary = colors[1];

export const original = {
  primary: originalPrimary,
  secondary: originalSecondary,
  tertiary: originalTertiary,
  quaternary: originalQuaternary,
};

export const comparative = {
  primary: comparativePrimary,
  secondary: comparativeSecondary,
  tertiary: comparativeTertiary,
  quaternary: comparativeQuaternary,
};

export const uiNextColors = [
  {
    original: '#0078D4',
    comparative: '#0078D4',
  },
  {
    original: '#022F22',
    comparative: '#022F22',
  },
  {
    original: '#E3008C',
    comparative: '#E3008C',
  },
  {
    original: '#4B003F',
    comparative: '#4B003F',
  },
];

export const uiNextOriginal = '#484644';

export const uiNextComparative = '#605e5c';
